/**
 * @desc 我销售的
 */
import {
  PageAuctionMemberPageItem,
  AuctionMemberPageParam
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryAuctionMemberSalePageParameter = AuctionMemberPageParam

const method = 'GET'
const url = '/trade/member/auction/sale/page'

export const queryAuctionMemberSalePageApi = (
  params?: QueryAuctionMemberSalePageParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PageAuctionMemberPageItem>({
    method,
    url,
    params,
    ...config
  })
}

queryAuctionMemberSalePageApi.method = method
queryAuctionMemberSalePageApi.url = url
